import { ItemSheetExtraTag } from "@/consts/Estimate";
import { CombinedRow } from "@/types/itemsheet";
import { ColumnDef } from "@tanstack/react-table";

export const createColumns = (): ColumnDef<CombinedRow>[] => [
  {
    id: "index",
    header: ({}) => <></>,
    cell: ({ row }) => (
      <span className="flex justify-center">{row.index + 1}</span>
    ),
    size: 40,
  },
  {
    accessorKey: "product_name",
    header: "제품명",
    cell: ({ row }) => {
      const { product_name, tags } = row.original;

      const isOwnProduct = tags.some(
        (tag) => tag === ItemSheetExtraTag.OWN_PRODUCT
      );

      return (
        <div className="">
          <span>{product_name}</span>
        </div>
      );
    },
    size: 223,
  },
  {
    accessorKey: "product_id",
    header: "제품 번호",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 166,
  },
  {
    accessorKey: "manufacturer",
    header: "제조사",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 146,
  },
  {
    accessorKey: "vendor",
    header: "벤더",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 127,
  },
  {
    accessorKey: "buyer",
    header: "구매업체",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 127,
  },
  {
    accessorKey: "specification",
    header: "규격",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 127,
  },
  {
    accessorKey: "unit",
    header: "단위",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 100,
  },
  {
    accessorKey: "quantity",
    header: "수량",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 120,
  },
  {
    accessorKey: "unit_cost",
    header: "단가",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 120,
  },
  {
    accessorKey: "list_price",
    header: "판매가",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 120,
  },
  {
    accessorKey: "total_cost",
    header: "매입가 합계",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 120,
  },
  {
    accessorKey: "total_list_price",
    header: "판매가 합계",
    cell: ({ row, column }) => {
      return <span>{row.getValue(column.id)}</span>;
    },
    size: 120,
  },
];
